export default __webpack_public_path__ + "static/media/flash02.d8df47a4.png";